module.exports = __webpack_public_path__ + "img/book-copy.5689240c.svg";